import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const STORE_KEY = "wall_region_v1";
const EVT = "wall:region";
export const MUSIC_CATEGORIES = new Set(["live-music", "karaoke", "open-mic"]);
export const BEYOND = { id: "beyond", label: "Beyond", long_label: "Touring & beyond the Sound", color: "#5C5C5C", cities: [] };

let regionsCache = null;
let regionsPromise = null;
export const fetchRegions = () => {
  if (regionsCache) return Promise.resolve(regionsCache);
  if (!regionsPromise) {
    regionsPromise = axios.get(`${API}/api/regions`).then((r) => { regionsCache = r.data.regions || []; return regionsCache; }).catch(() => (regionsCache = []));
  }
  return regionsPromise;
};

const REGIONS_EVT = "wall:regions-updated";
export const setRegionsCache = (list) => { regionsCache = list; window.dispatchEvent(new CustomEvent(REGIONS_EVT, { detail: list })); };

export const useRegions = () => {
  const [regions, setRegions] = useState(regionsCache || []);
  useEffect(() => {
    fetchRegions().then(setRegions);
    const on = (e) => setRegions(e.detail);
    window.addEventListener(REGIONS_EVT, on);
    return () => window.removeEventListener(REGIONS_EVT, on);
  }, []);
  return regions;
};

export const visibleRegions = (regions) => regions.filter((r) => r.enabled !== false);
export const visibleCities = (r) => (r.cities || []).filter((c) => !(r.hidden_cities || []).some((h) => h.toLowerCase() === c.toLowerCase()));

const read = () => {
  try { const v = JSON.parse(localStorage.getItem(STORE_KEY) || "null"); if (v && typeof v.region === "string") return { region: v.region, city: v.city || null }; } catch { /* ignore */ }
  return { region: "all", city: null };
};

// Region selection shared by the home map and /events: localStorage-backed, synced across mounted components.
export const useRegionSelection = () => {
  const [sel, setSelState] = useState(read);
  useEffect(() => {
    const on = (e) => setSelState(e.detail);
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const setSel = (next) => {
    const v = typeof next === "function" ? next(read()) : next;
    const clean = { region: v.region || "all", city: v.region && v.region !== "all" ? v.city || null : null };
    localStorage.setItem(STORE_KEY, JSON.stringify(clean));
    window.dispatchEvent(new CustomEvent(EVT, { detail: clean }));
  };
  return [sel, setSel];
};

const norm = (s) => (s || "").trim().toLowerCase();

export const regionOfCity = (city, regions) => {
  const c = norm(city);
  if (!c) return null;
  return regions.find((r) => (r.cities || []).some((x) => norm(x) === c)) || null;
};

// Music is exempt from the region filter by design: a Tacoma → Bremerton show is a short drive.
export const inRegion = (ev, sel, regions, { musicEverywhere = true } = {}) => {
  if (!sel || sel.region === "all") return true;
  if (musicEverywhere && MUSIC_CATEGORIES.has(ev.category)) return true;
  const city = norm(ev.city);
  if (sel.region === BEYOND.id) return !regionOfCity(city, regions);
  const r = regions.find((x) => x.id === sel.region);
  if (!r) return true;
  if (sel.city) return city === norm(sel.city);
  return (r.cities || []).some((x) => norm(x) === city);
};

export const countByRegion = (events, regions) => {
  const counts = { all: events.length, [BEYOND.id]: 0 };
  const cities = {};
  regions.forEach((r) => { counts[r.id] = 0; });
  for (const ev of events) {
    const r = regionOfCity(ev.city, regions);
    if (r) { counts[r.id] += 1; const k = `${r.id}:${norm(ev.city)}`; cities[k] = (cities[k] || 0) + 1; }
    else if (norm(ev.city)) counts[BEYOND.id] += 1;
  }
  return { counts, cities };
};
